module.exports = __webpack_public_path__ + "img/ic-speedometer-1.7ff74064.png";